import React, { useEffect, useState } from 'react'
import CustomPage from './Custom-page'
import AuthPage from '../gohighlevel/auth/AuthPage'
import axiosApi from '../axiosApi/axiosApi';
import { Flex, message } from 'antd';
import SignInToHighLevel from '../gohighlevel/SignInToHighLevel';
import LogoutButton from '../gohighlevel/auth/logout';

export default function GhlPage() {
  const [hasLoggedIn, setHasLoggedIn] = useState(false);
  const [isGolevelSignedIn, setIsGolevelSignedIn] = useState('');
  const [isGhlSignLoading, setIsGhlSignLoading] = useState(false);
  let isStoreLoginIn = localStorage.getItem('authToken')

  useEffect(() => {
    setIsGhlSignLoading(true)
    const confirmGhlSignIn = async () => {
      try {
        let { data } = await axiosApi.get('/Is-usergohighlevelsignin')
        setIsGolevelSignedIn(data?.signedIn)

      } catch (error) {
        console.log(error, 'eroror');
        message.error('request faild, refresh the page')
      } finally {
        setIsGhlSignLoading(false)
      }
    }
    if (isStoreLoginIn) {
      confirmGhlSignIn()
    }

  }, [isStoreLoginIn])

  return (
    <>
      {
        hasLoggedIn || isStoreLoginIn ?
          !isGolevelSignedIn ?
            <>
              <Flex align='centr' style={{ width: '95%', paddingTop: 20 }} justify='flex-end'>
                <LogoutButton />
              </Flex>
              <SignInToHighLevel isGhlSignLoading={isGhlSignLoading} setIsGhlSignLoading={setIsGhlSignLoading} />
            </>
            :
            <CustomPage />
          :
          <AuthPage setHasLoggedIn={setHasLoggedIn} />
      }
    </>

  )
}
